import { InfoIcon } from "./Icons";
import VLTooltip from "../../../uikit/VLTooltip";
import DescriptionList from "../../../components/DescriptionList";
import { Dataset } from "../../../../types";
import { useFeatureFlagService } from "../../../../hooks/useFeatureFlagService";
import { DATASETS_JOB_SETUP_RECIPE_FILTERS } from "../../../../helpers/constants/filters";
import { useCamtekMetadata } from "views/components/DescriptionList/useCamtekMetadata";

type DatasetInfoIconProps = {
  dataset: Dataset;
  showDatasetInfo?: boolean;
  datasetLastUpdated?: string;
};

export const DatasetInfoIcon = ({
  dataset,
  showDatasetInfo,
  datasetLastUpdated,
}: DatasetInfoIconProps) => {
  const datasetsJobSetupRecipeFiltersEnabled = useFeatureFlagService(
    DATASETS_JOB_SETUP_RECIPE_FILTERS,
  ).enabled;

  const { hasJobSetupRecipeMetadata } = useCamtekMetadata(dataset);

  const shouldShowPopover =
    showDatasetInfo ||
    (datasetsJobSetupRecipeFiltersEnabled && hasJobSetupRecipeMetadata);

  if (!shouldShowPopover) return null;

  return (
    <VLTooltip
      title={
        <DescriptionList
          dataset={dataset}
          showJobSetupRecipe
          showDatasetInfo={showDatasetInfo}
          datasetLastUpdated={datasetLastUpdated}
          mode="vertical"
        />
      }
    >
      <InfoIcon />
    </VLTooltip>
  );
};
